import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { getUserData } from "utils/userData";
import { getDashboardPath } from "services/api";

const accessCards = [
  {
    title: "Pemohon / Masyarakat",
    description: "Ajukan permohonan perizinan, unggah dokumen, dan pantau status pengajuan Anda.",
    icon: "person",
    color: "info",
    actions: [
      { label: "Login Pemohon", to: "/authentication/sign-in/cover", variant: "gradient" },
      { label: "Daftar Akun Baru", to: "/authentication/sign-up/cover", variant: "outlined" },
    ],
  },
  {
    title: "Petugas & Verifikator",
    description: "Verifikasi berkas, proses rekomendasi teknis, dan kelola alur pelayanan perizinan.",
    icon: "badge",
    color: "success",
    actions: [{ label: "Login Petugas / Staff", to: "/authentication/sign-in/cover", variant: "gradient" }],
  },
  {
    title: "Verifikasi Dokumen Izin",
    description: "Periksa keaslian dokumen izin yang diterbitkan melalui kode verifikasi atau QR code.",
    icon: "qr_code_scanner",
    color: "dark",
    actions: [{ label: "Info Verifikasi", scrollTo: "layanan", variant: "outlined" }],
  },
];

function AccessSection() {
  const { userRole } = getUserData();

  return (
    <MDBox id="akses" component="section" py={8} bgColor="grey-100">
      <Container>
        <MDBox textAlign="center" mb={5}>
          <MDTypography variant="h3" fontWeight="bold" mb={1}>
            Akses Sistem TIALAI
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Masuk ke sistem sesuai peran Anda untuk menggunakan layanan digital DPMPTSP
          </MDTypography>
        </MDBox>

        {userRole && (
          <MDBox textAlign="center" mb={4}>
            <MDButton variant="gradient" color="success" size="large" component={Link} to={getDashboardPath(userRole)}>
              Buka Dashboard Saya
            </MDButton>
          </MDBox>
        )}

        <Grid container spacing={3}>
          {accessCards.map((card) => (
            <Grid item xs={12} md={4} key={card.title}>
              <Card sx={{ height: "100%" }}>
                <MDBox p={3} display="flex" flexDirection="column" height="100%" textAlign="center">
                  <MDBox
                    variant="gradient"
                    bgColor={card.color}
                    color="white"
                    width="4rem"
                    height="4rem"
                    borderRadius="md"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mx="auto"
                    mb={2}
                    shadow="md"
                  >
                    <Icon>{card.icon}</Icon>
                  </MDBox>
                  <MDTypography variant="h5" fontWeight="medium" mb={1}>
                    {card.title}
                  </MDTypography>
                  <MDTypography variant="body2" color="text" mb={3} flex={1}>
                    {card.description}
                  </MDTypography>
                  <MDBox display="flex" flexDirection="column" gap={1}>
                    {card.actions.map((action) =>
                      action.scrollTo ? (
                        <MDButton
                          key={action.label}
                          variant={action.variant}
                          color={card.color}
                          onClick={() =>
                            document.getElementById(action.scrollTo)?.scrollIntoView({ behavior: "smooth" })
                          }
                        >
                          {action.label}
                        </MDButton>
                      ) : (
                        <MDButton
                          key={action.label}
                          variant={action.variant}
                          color={card.color}
                          component={Link}
                          to={action.to}
                        >
                          {action.label}
                        </MDButton>
                      )
                    )}
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MDBox>
  );
}

export default AccessSection;
